import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Komoditas from "../pages/referensi/komoditas/";
import AddKomoditas from "../pages/referensi/komoditas/addItem";
const ReferensiRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          <Route path="/referensi/komoditas/" exact component={Komoditas} />
          <Route
            path="/referensi/komoditas/add"
            exact
            component={AddKomoditas}
          />
          <Route
            path="/referensi/komoditas/edit/:idItem"
            exact
            component={AddKomoditas}
          />
          {/* Finance References */}
          <Route path="/referensi/finance" exact component={require("../pages/master-data/FinanceReference/index").default} />

          {/* Contact Routes */}
          <Route path="/referensi/kontak" exact component={require("../pages/referensi/contact").default} />
          <Route path="/referensi/kontak/create" exact component={require("../pages/referensi/contact/form").default} />
          <Route path="/referensi/kontak/edit/:id" exact component={require("../pages/referensi/contact/form").default} />

          {/* User Routes */}
          <Route path="/referensi/users" exact component={require("../pages/referensi/users").default} />
          <Route path="/referensi/users/create" exact component={require("../pages/referensi/users/form").default} />
          <Route path="/referensi/users/edit/:id" exact component={require("../pages/referensi/users/form").default} />

          {/* Role Access Routes */}
          <Route path="/referensi/roles" exact component={require("../pages/role-access/RoleAccess").default} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default ReferensiRouter;
